import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { useLangFile } from 'js/context/LanguageContext';
import Box from '@mui/material/Box';
import Styles from './PrescriptionTableToolbar.module.less';
import { voidFunc } from '../../constants/PropTypeUtils';
import useMediaQuery from '@mui/material/useMediaQuery';

const PrescriptionTableToolbar = (props: PrescriptionTableToolbar.props) => {
  const LangFile = useLangFile();

  const disableGutters = useMediaQuery('(max-width:800px)');

  return (
    <Toolbar disableGutters={disableGutters}>
      <Box className={Styles.titleContainer}>
        <Typography variant="h6" id="tableTitle">
          {LangFile.PrescriptionTableToolbar.tableTitle}
        </Typography>
        {props.numberOfExcludedFields > 0 && (
          <Box className={Styles.filterContainer}>
            <Typography
              className={Styles.italicTypography}
              variant="body2"
              sx={{
                color: 'inherit',
              }}
            >
              {props.numberOfExcludedFields} {LangFile.PrescriptionTableToolbar.fieldsNotShown}
            </Typography>
            <Typography
              className={Styles.clickableTypography}
              color="primary"
              variant="body2"
              onClick={props.onFilterReset}
            >
              {LangFile.PrescriptionTableToolbar.resetFilters}
            </Typography>
          </Box>
        )}
      </Box>
    </Toolbar>
  );
};

PrescriptionTableToolbar.propTypes = {
  numberOfExcludedFields: PropTypes.number,
  onFilterReset: PropTypes.func,
};

PrescriptionTableToolbar.defaultProps = {
  numberOfExcludedFields: 0,
  onFilterReset: voidFunc,
};

export default memo(PrescriptionTableToolbar);
